module.exports = __webpack_public_path__ + "img/nthu-logo.e39850d4.png";